/*
 * 基础弹窗的封装
 * 项目中所有自定义弹窗用此封装
 * 先凑合用 后面有时间了再考虑换成根据底层Modal的封装
 */

import React from 'react';
import { Modal } from 'antd';
import ModalClose from '@ui/button/modal-close';
import globalStore from '@src/store/global';

const BaseModal = {
  show(data) {
    const _Model = globalStore.AntdModal || Modal;

    const { title, closeProps, ...restData } = data;
    const config = {
      title: null,
      closeIcon: (
        <ModalClose
          className={data.closeClassName}
          onClose={() => data.onCancel?.()}
          {...closeProps}
        />
      ), //自定义关闭图标	ReactNode<CloseOutlined />
      icon: null,
      //forceRender:true,
      destroyOnClose: true, //关闭时销毁 Modal 里的子元素	boolean	false
      focusTriggerAfterClose: false, //对话框关闭后是否需要聚焦触发元素	boolean	true	4.9.0
      bodyStyle: { padding: 0 }, //Modal .ant-modal-body 样式
      afterClose: data.afterClose || (evt => {}), //	Modal 完全关闭后的回调
      centered: true, //	垂直居中展示
      closable: true, //	是否显示右上角的关闭按钮
      //footer: null,//不支持，用okButtonProps
      getContainer: document.getElementById('nworld-app-modal-container'), //指定 Modal 挂载的节点，但依旧为全局展示，false 为挂载在当前位置	HTMLElement | () => HTMLElement | Selectors | false	document.body
      keyboard: true, //是否支持键盘 esc 关闭
      mask: true, //是否展示遮罩
      maskClosable: true, //点击蒙层是否允许关闭
      maskColor: 'rgba(0,0,0,0.5)', //点击蒙层是否允许关闭
      width: 'auto',
      transitionName: '', //弹窗动画
      //maskTransitionName: '',//弹窗动画
      cancelButtonProps: { style: { display: 'none' } }, // 隐藏cancel按钮
      okButtonProps: { style: { display: 'none' } }, // 隐藏ok按钮
      wrapClassName: 'nw-base-modal',
      ...restData,
    };
    const res = _Model.confirm(config);
    //不同的弹窗有不同的圆角 用css处理不了
    setTimeout(() => {
      const modalWrap = document.querySelectorAll(
        '.nw-base-modal .ant-modal-confirm-confirm'
      );
      const mask = document.querySelectorAll(
        '#nworld-app-modal-container .ant-modal-mask'
      );
      if (mask.length > 0 && data.maskClassName) {
        mask[mask.length - 1].setAttribute('data-classname', data.maskClassName);
      }
      if (mask.length > 0 && data.maskColor) {
        mask[mask.length - 1].style.backgroundColor = data.maskColor;
      } else {
        try {
          mask[mask.length - 1].style.backgroundColor = config.maskColor; // 设计要求默认80%
        } catch (error) {}
      }
      if (modalWrap.length > 0) {
        modalWrap[modalWrap.length - 1].style.borderRadius = `${
          data.borderRadius || 8
        }px`;
      }
      data.readyInit && data.readyInit();
    }, 20);

    return res;
  },
};

export default BaseModal;
